import { memo, type ReactNode } from 'react';
import { cn } from '@restworld/utils-common';

export interface FormLabelWrapperProps {
  label?: ReactNode;
  id?: string;
  children: ReactNode;
  disabled?: boolean;
  isFullWidth?: boolean;
  className?: string;
}

export const FormLabelWrapper = memo(
  ({ label, id, disabled, children, isFullWidth, className }: FormLabelWrapperProps) => (
    <div className={cn(isFullWidth && 'w-full', className)}>
      {label ? (
        <div className="mb-2 block">
          <label htmlFor={id} className={cn(disabled && 'text-gray-400')}>
            {label}
          </label>
        </div>
      ) : null}
      {children}
    </div>
  )
);
FormLabelWrapper.displayName = 'FormLabelWrapper';
